export default __webpack_public_path__ + "static/media/logo-lidera-fgcoop.a37218e2.png";